import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/layout/layout'
import CustomLayout from '@/layout/CustomLayout'
import _ from 'lodash'
export const constantRoutes = []
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// //修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(VueRouter)
// hidden为true则不会展示在menu
const routes = [
  {
    path: '/',
    name: 'Home page',
    component: CustomLayout,
    redirect: '/personalCenter',
    children: [
      {
        path: '/personalCenter',
        name: 'Personal center',
        isTop: true,
        hidden: true,
        meta: {
          rootPath: '/personalCenter',
          title: 'Personal center', // 导航菜单显示的名称
          icon: 'el-icon-files',
          disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
        },
        // 切换nav菜单时默认选中第一个
        redirect: '/personalCenter/personalInfo',
        component: Layout,
        children: [
          {
            path: '/personalCenter/personalInfo',
            name: 'Personal information',
            meta: {
              isTag: true,
              rootPath: '/personalCenter',
              title: 'Personal information', // 导航菜单显示的名称
              icon: 'el-icon-group', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/personalCenter' //对应左边菜单的好亮的路由
            }, // 路由meta信息
            component: () => import('@/pages/PersonalCenter/PersonalInfo')
          },
          {
            path: '/personalCenter/auditManagement',
            name: 'Audit management',
            meta: {
              isTag: true,
              rootPath: '/personalCenter',
              title: 'Audit management', // 导航菜单显示的名称
              icon: 'el-icon-finished', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/personalCenter'
            }, // 路由meta信息
            component: () => import('@/pages/PersonalCenter/auditManagement')
          },
          {
            path: '/personalCenter/shareManagment',
            name: 'Sharing managment',
            meta: {
              isTag: true,
              rootPath: '/personalCenter',
              title: 'Sharing managment', // 导航菜单显示的名称
              icon: 'el-icon-edit-outline', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/personalCenter'
            }, // 路由meta信息
            component: () => import('@/pages/PersonalCenter/SharingManagement')
          }
        ]
      },
      {
        path: '/design',
        name: 'Experience Design Tools',
        meta: {
          noSelected: true, // 是否跳过 不选中该菜 单重定向页签
          rootPath: '/design',
          title: 'Experience Design Tools', // 导航菜单显示的名称
          icon: 'el-icon-setting', // 导航菜单icon
          disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
        },
        // 切换nav菜单时默认选中第一个
        redirect: '/design/journeyMap',
        isTop: true,
        component: Layout,
        children: [
          {
            path: '/design/journeyMap',
            name: 'User journey map',
            isSide: true,
            meta: {
              isTag: true,
              rootPath: '/design',
              title: 'User journey map', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/design/journeyMap'
            }, // 路由meta信息
            component: () => import('@/pages/Design/UserJourneyMap')
          },
          {
            path: '/design/bluePrint',
            name: 'Service blueprint',
            isSide: true,
            meta: {
              isTag: true,
              rootPath: '/design',
              title: 'Service blueprint', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/design/bluePrint'
            }, // 路由meta信息
            component: () => import('@/pages/Design/BluePrint')
          }
        ]
      },
      {
        path: '/monitorOverview',
        name: 'Monitoring the overview',
        isTop: true,
        meta: {
          rootPath: '/monitorOverview',
          title: 'Monitoring the overview', // 导航菜单显示的名称
          icon: 'el-icon-c-scale-to-original', // 导航菜单icon
          disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
        },
        // 切换nav菜单时默认选中第一个
        redirect: '/monitorOverview/journeyContact',
        component: Layout,
        children: [
          {
            path: '/monitorOverview/journeyContact',
            name: 'Journey of contact',
            subHidden: true, // 不展示子级
            isSide: true,
            meta: {
              rootPath: '/monitorOverview',
              title: 'Journey of contact', // 导航菜单显示的名称
              // icon: 'el-icon-odometer', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/monitorOverview/journeyContact'
            }, // 路由meta信息
            redirect: '/monitorOverview/journeyContact',
            component: Layout,
            children: [
              {
                path: '/monitorOverview/journeyContact',
                name: 'Journey of the list',
                hidden: true,
                meta: {
                  isTag: true,
                  rootPath: '/monitorOverview',
                  title: 'Journey of the list', // 导航菜单显示的名称
                  // icon: 'el-icon-odometer', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/monitorOverview/journeyContact'
                }, // 路由meta信息
                component: () =>
                  import(
                    '@/pages/MonitorOverview/JourneyContact/JourneyContact/index'
                  )
              },
              {
                path: '/monitorOverview/journeyContact/contactDetail',
                name: 'Journey contact details view',
                meta: {
                  rootPath: '/monitorOverview',
                  title: 'Journey contact details View', // 导航菜单显示的名称
                  // icon: 'el-icon-odometer', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/monitorOverview/journeyContact'
                }, // 路由meta信息
                component: () =>
                  import('@/pages/MonitorOverview/JourneyContact/ContactDetail')
              }
            ]
          },
          {
            path: '/monitorOverview/contactMonitor',
            name: 'Contactmonitoring',
            subHidden: true, // 不展示子级
            isSide: true,
            meta: {
              rootPath: '/monitorOverview',
              title: 'Contactmonitoring', // 导航菜单显示的名称
              // icon: 'el-icon-c-scale-to-original', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/monitorOverview/contactMonitor'
            }, // 路由meta信息
            redirect: '/monitorOverview/contactMonitor',
            component: Layout,
            children: [
              {
                path: '/monitorOverview/contactMonitor',
                name: 'Contact monitor of the list',
                hidden: true,
                meta: {
                  isTag: true,
                  rootPath: '/monitorOverview',
                  title: 'Contact monitor of the list', // 导航菜单显示的名称
                  // icon: 'el-icon-odometer', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/monitorOverview/contactMonitor'
                }, // 路由meta信息
                component: () =>
                  import(
                    '@/pages/MonitorOverview/ContactMonitor/ContactMonitor/index'
                  )
              },
              {
                path: '/monitorOverview/createResearch',
                name: 'Create research',
                hidden: true,
                meta: {
                  rootPath: '/monitorOverview',
                  isTag: true,
                  title: 'Create research', // 导航菜单显示的名称
                  // icon: 'el-icon-odometer', // 导航菜单icon
                  keepAlive: true,
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/monitorOverview/contactMonitor'
                }, // 路由meta信息
                component: () =>
                  import(
                    '@/pages/MonitorOverview/ContactMonitor/newCreateResearch' //newCreateResearch
                  )
              },
              {
                path: '/monitorOverview/editResearch',
                name: 'Edit research',
                hidden: true,
                meta: {
                  rootPath: '/monitorOverview',
                  title: 'Edit research', // 导航菜单显示的名称
                  // icon: 'el-icon-odometer', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/monitorOverview/contactMonitor'
                }, // 路由meta信息
                component: () =>
                  import(
                    '@/pages/MonitorOverview/ContactMonitor/CreateAndEditResearch'
                  )
              },
              {
                path: '/monitorOverview/researchDetail',
                name: 'Research detail',
                hidden: true,
                meta: {
                  rootPath: '/monitorOverview',
                  title: 'Research detail', // 导航菜单显示的名称
                  // icon: 'el-icon-odometer', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/monitorOverview/contactMonitor'
                }, // 路由meta信息
                component: () =>
                  import(
                    '@/pages/MonitorOverview/ContactMonitor/ResearchDetail'
                  )
              },
              {
                path: '/monitorOverview/shareLink',
                name: 'Create research',
                hidden: true,
                meta: {
                  rootPath: '/monitorOverview',
                  title: 'Create research', // 导航菜单显示的名称
                  // icon: 'el-icon-odometer', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/monitorOverview/contactMonitor'
                }, // 路由meta信息
                component: () =>
                  import('@/pages/MonitorOverview/ContactMonitor/ShareLink')
              }
            ]
          }
        ]
      },
      {
        path: '/content',
        name: 'Content configuration',
        isTop: true,
        meta: {
          rootPath: '/content',
          title: 'Content configuration', // 导航菜单显示的名称
          icon: 'el-icon-document', // 导航菜单icon
          disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
        },
        // 切换nav菜单时默认选中第一个
        redirect: '/content/surveyManagement',
        component: Layout,
        children: [
          {
            path: '/content/surveyManagement',
            name: 'Survey questionnaire',
            subHidden: true, // 不展示子级
            isSide: true,
            meta: {
              isTag: true,
              rootPath: '/content',
              title: 'Survey questionnaire', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
            },
            redirect: '/content/surveyManagement/surveyList',
            component: () => import('@/pages/Survey/SurveyManagement'),
            children: [
              {
                path: '/content/surveyManagement/surveyList',
                name: 'Questionnaire list',
                meta: {
                  rootPath: '/content',
                  title: 'Questionnaire list', // 导航菜单显示的名称
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/content/surveyManagement'
                },
                component: () =>
                  import(
                    '@/pages/Survey/SurveyManagement/components/SurveyList'
                  )
              },
              {
                path: '/content/surveyManagement/addSurvey',
                name: 'Add questionnaire',
                meta: {
                  rootPath: '/content',
                  title: 'Add questionnaire', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/content/surveyManagement'
                },
                component: () =>
                  import(
                    '@/pages/Survey/SurveyManagement/components/SurveyContent'
                  )
              }
            ]
          },
          {
            path: '/content/templateList',
            name: 'Template management',
            meta: {
              isTag: true,
              rootPath: '/content',
              title: 'Template management', // 导航菜单显示的名称
              // icon: 'el-icon-document',
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/content/templateList'
            }, // 路由meta信息
            component: () =>
              import('@/pages/TemplateConfiguration/templateList')
          },
          {
            path: '/content/templateDetail',
            name: 'Template details',
            hidden: true,
            meta: {
              rootPath: '/content',
              title: 'Template details', // 导航菜单显示的名称
              icon: '', // 导航菜单icon
              breadcrumb: true,
              leftMenuPath: '/content/templateList'
            }, // 路由meta信息
            component: () =>
              import('@/pages/TemplateConfiguration/templateDetail')
          }
        ]
      },
      {
        path: '/dataAnalysis',
        isTop: true,
        name: 'Data analysis',
        meta: {
          rootPath: '/dataAnalysis',
          title: 'Data analysis', // 导航菜单显示的名称
          icon: 'el-icon-odometer', // 导航菜单icon
          disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
        },
        // 切换nav菜单时默认选中第一个
        redirect: '/dataAnalysis/surveyData',
        component: Layout,
        children: [
          // {
          //   path: '/dataAnalysis/pushAndRecovery',
          //   name: 'Push collection statistics',
          //   meta: {
          //     isTag: true,
          //     rootPath: '/dataAnalysis',
          //     title: 'Push collection statistics', // 导航菜单显示的名称
          //     icon: 'el-icon-setting', // 导航菜单icon
          //     disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          //     breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
          //   },
          //   component: () => import('@/pages/Survey/PushAndRecovery')
          // },
          {
            path: '/dataAnalysis/surveyData',
            name: 'Research Statistics',
            subHidden: true,
            isSide: true,
            meta: {
              isTag: true,
              rootPath: '/dataAnalysis',
              title: 'Research Statistics', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
            },
            redirect: '/dataAnalysis/surveyData',
            component: Layout,
            children: [
              {
                path: '/dataAnalysis/surveyData',
                name: 'Research Statistics',
                hidden: true,
                meta: {
                  isTag: false,
                  rootPath: '/dataAnalysis',
                  title: 'Research Statistics', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/dataAnalysis/surveyData'
                },
                component: () => import('@/pages/Survey/SurveyData')
              },
              {
                path: '/dataAnalysis/surveyData/detail/:surveyId/:startDate/:endDate/:feedbackId?/:tab?',
                name: 'statisticsDetail',
                hidden: true,
                meta: {
                  isTag: false,
                  rootPath: '/dataAnalysis',
                  title: 'statisticsDetail', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/dataAnalysis/surveyData'
                },
                component: () => import('@/pages/Survey/SurveyDataDetail'),
                props: true
              }
            ]
          },
          {
            path: '/dataAnalysis/userData',
            name: 'User Record Analysis',
            subHidden: true,
            isSide: true,
            meta: {
              isTag: true,
              rootPath: '/dataAnalysis',
              title: 'User Record Analysis', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
            },
            redirect: '/dataAnalysis/userData',
            component: Layout,
            children: [
              {
                path: '/dataAnalysis/userData',
                name: 'User Record Analysis',
                hidden: true,
                meta: {
                  isTag: false,
                  rootPath: '/dataAnalysis',
                  title: 'statistics', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/dataAnalysis/userData'
                },
                component: () => import('@/pages/Survey/UserData')
              },
              {
                path: '/dataAnalysis/userData/detail',
                name: 'User Record Analysis',
                hidden: true,
                meta: {
                  isTag: false,
                  rootPath: '/dataAnalysis',
                  title: 'User Record Analysis', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/dataAnalysis/userData'
                },
                component: () => import('@/pages/Survey/UserDataDetail')
              }
            ]
          },
          {
            path: '/dataAnalysis/dataSubscribe',
            name: 'Data Subscription',
            subHidden: true,
            isSide: true,
            meta: {
              isTag: true,
              rootPath: '/dataAnalysis',
              title: 'Data Subscription', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
            },
            redirect: '/dataAnalysis/dataSubscribe',
            component: Layout,
            children: [
              {
                path: '/dataAnalysis/dataSubscribe',
                name: 'Data Subscription',
                subHidden: true,
                // hidden: true,
                meta: {
                  isTag: false,
                  rootPath: '/dataAnalysis',
                  title: 'Data Subscription', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/dataAnalysis/dataSubscribe'
                },
                component: () =>
                  import('@/pages/Survey/DataSubscription/SubscriptionList')
              },
              {
                path: '/dataAnalysis/subscribeEdit',
                name: 'New Subscription',
                hidden: true,
                meta: {
                  // isTag: false,
                  rootPath: '/dataAnalysis',
                  title: 'New Subscription', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/dataAnalysis/dataSubscribe'
                },
                component: () =>
                  import(
                    '@/pages/Survey/DataSubscription/SubscriptionList/SubscriptionEdit'
                  )
              }
            ]
          }
        ]
      },
      {
        path: '/preWarning',
        name: 'Bad review warning',
        meta: {
          isTag: true,
          rootPath: '/preWarning',
          title: 'Bad review warning', // 导航菜单显示的名称
          icon: 'el-icon-set-up', // 导航菜单icon
          disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
        },
        // 切换nav菜单时默认选中第一个
        redirect: '/preWarning/preWarningRule',
        // component: () => import('@/pages/PreWarning/PreWarningList'),
        component: Layout,
        children: [
          {
            path: '/preWarning/preWarningRule',
            name: 'Warning rules',
            subHidden: true,
            meta: {
              rootPath: '/preWarning',
              title: 'Warning rules', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: true, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
            },
            component: Layout,
            redirect: '/preWarning/preWarningRule',
            children: [
              {
                path: '/preWarning/preWarningRule',
                name: 'Warning rules_1',
                subHidden: true,
                meta: {
                  rootPath: '/preWarning',
                  title: 'Warning rules', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: false, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/preWarning/preWarningRule'
                },
                component: () =>
                  import('../../src/pages/PreWarning/PreWarningList')
              },
              {
                path: '/preWarning/preWarningRuleEdit',
                name: 'newWraning',
                hidden: true,
                meta: {
                  rootPath: '/preWarning',
                  title: 'newWraning', // 导航菜单显示的名称
                  // icon: 'el-icon-setting', // 导航菜单icon
                  disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
                  breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
                  leftMenuPath: '/preWarning/preWarningRule'
                },
                component: () =>
                  import('@/pages/PreWarning/PreWarningList/PreWarningEdit')
              }
            ]
          },
          {
            path: '/preWarning/preWarning',
            name: 'Warning the closed-loop',
            hidden: true,
            meta: {
              rootPath: '/preWarning',
              title: 'Warning the closed-loop', // 导航菜单显示的名称
              // icon: 'el-icon-setting', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/preWarning/preWarning'
            },
            component: () => import('@/pages/PreWarning/PreWarning')
          }
          // {
          //   path: '/preWarning/preWarningData',
          //   name: 'Warning data',
          //   meta: {
          //     isTag: true,
          //     rootPath: '/preWarning',
          //     title: 'Warning data', // 导航菜单显示的名称
          //     // icon: 'el-icon-setting', // 导航菜单icon
          //     disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          //     breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
          //     leftMenuPath: '/preWarning/preWarningData'
          //   },
          //   component: () => import('@/pages/PreWarning/PreWarningData')
          // }
        ]
      },
      {
        path: '/setting',
        name: 'Authority management',
        // hidden: true,
        meta: {
          rootPath: '/setting',
          title: 'Authority management', // 导航菜单显示的名称
          icon: 'el-icon-group', // 导航菜单icon
          disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          breadcrumb: true // 当false时，表示当前路由item不在面包屑展示信息，默认true
        },
        // 切换nav菜单时默认选中第一个
        redirect: '/setting/accountGroupManagement',
        component: Layout,
        children: [
          {
            path: '/setting/accountGroupManagement',
            name: 'Account Group Management',
            meta: {
              isTag: true,
              rootPath: '/setting',
              title: 'Account Group Management', // 导航菜单显示的名称
              // icon: 'el-icon-group', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/setting/accountGroupManagement'
            }, // 路由meta信息
            component: () => import('@/pages/Setting/accountGroupManagement')
          },
          {
            path: '/setting/accountManagement/detail',
            name: 'Account details',
            hidden: true,
            meta: {
              rootPath: '/setting',
              title: 'Account details', // 导航菜单显示的名称
              icon: '', // 导航菜单icon
              leftMenuPath: '/setting/accountGroupManagement'
            }, // 路由meta信息
            component: () =>
              import(
                '@/pages/Setting/accountManagement/components/accountGroupDetail'
              )
          },
          {
            path: '/setting/roleManagement',
            name: 'Role management',
            meta: {
              isTag: true,
              rootPath: '/setting',
              title: 'Role management', // 导航菜单显示的名称
              // icon: 'el-icon-user-add', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/setting/roleManagement'
            }, // 路由meta信息
            component: () => import('@/pages/Setting/roleManagement')
          },
          {
            path: '/setting/accountManagement',
            name: 'Account management',
            meta: {
              isTag: true,
              rootPath: '/setting',
              title: 'Account management', // 导航菜单显示的名称
              // icon: 'el-icon-user', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/setting/accountManagement'
            }, // 路由meta信息
            component: () => import('@/pages/Setting/accountManagement')
          },
          {
            path: '/setting/announcementManagement',
            name: 'Announcement management',
            meta: {
              isTag: true,
              rootPath: '/setting',
              title: 'Announcement management', // 导航菜单显示的名称
              // icon: 'el-icon-user', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/setting/announcementManagement'
            }, // 路由meta信息
            component: () => import('@/pages/Setting/announcementManagement')
          },
          {
            path: '/setting/systemFeedback',
            name: 'systemFeedback',
            meta: {
              isTag: true,
              rootPath: '/setting',
              title: 'systemFeedback', // 导航菜单显示的名称
              // icon: 'el-icon-user', // 导航菜单icon
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/setting/systemFeedback'
            }, // 路由meta信息
            component: () => import('@/pages/Setting/systemFeedback')
          },
          {
            path: '/setting/userEvent',
            name: 'userEvent',
            meta: {
              isTag: true,
              rootPath: '/setting',
              title: 'userEvent', // 导航菜单显示的名称
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/setting/userEvent'
            }, // 路由meta信息
            component: () => import('@/pages/Setting/userEvent')
          },
          {
            path: '/setting/handoverManagement',
            name: 'handoverManagement',
            meta: {
              isTag: true,
              rootPath: '/setting',
              title: 'handoverManagement', // 导航菜单显示的名称
              disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
              breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
              leftMenuPath: '/setting/handoverManagement'
            }, // 路由meta信息
            component: () => import('@/pages/Setting/handoverManagement')
          }

          // {
          //   path: '/setting/approval',
          //   name: 'approval',
          //   meta: {
          //     isTag: true,
          //     rootPath: '/setting',
          //     title: 'approval', // 导航菜单显示的名称
          //     disabledToLink: false, // 点击导航菜单时候提升事件，不跳转，默认false
          //     breadcrumb: true, // 当false时，表示当前路由item不在面包屑展示信息，默认true
          //     leftMenuPath: '/setting/approval'
          //   }, // 路由meta信息
          //   component: () => import('@/pages/Setting/approval')
          // }
        ]
      }
    ]
  },
  {
    path: '/answerSurvey/:collector?', //正式问卷
    name: 'answerSurvey',
    hidden: true,
    component: () => import('@/pages/Survey/AnswerSurvey'),
    meta: { title: '答题问卷', index: 3 }
  },
  {
    path: '/preview/:collector?', //预览问卷
    name: 'answerSurvey',
    hidden: true,
    component: () => import('@/pages/Survey/AnswerSurvey'),
    meta: { title: '答题问卷', index: 3, isReadOnly: true }
  },
  {
    path: '/surveyDetail',
    name: 'surveyDetail',
    hidden: true,
    component: () =>
      import('@/pages/Survey/SurveyManagement/components/SurveyDetail'),
    meta: { title: '问卷详情', index: 3 }
  },
  {
    path: '/surveyDetailPreviewPhone',
    name: 'surveyDetailPreviewPhone',
    hidden: true,
    component: () =>
      import(
        '@/pages/Survey/SurveyManagement/components/SurveyDetail/compontents/surveyPreviewContent'
      ),
    meta: { title: '问卷详情', index: 3 }
  },
  {
    path: '/surveyDetailPreview',
    name: 'surveyDetailPreview',
    hidden: true,
    component: () =>
      import(
        '@/pages/Survey/SurveyManagement/components/SurveyDetail/compontents/surveyPreview'
      ),
    meta: { title: '问卷预览', index: 3 }
  },
  {
    path: '/survey/answerInfo',
    name: 'answerInfo',
    hidden: true,
    component: () =>
      import(
        '@/pages/Survey/SurveyManagement/components/SurveyDetail/compontents/answerInfo'
      ),
    meta: { title: '答卷详情', index: 3 }
  },
  {
    path: '/announcementManagement',
    name: 'announcementManagement',
    hidden: true,
    component: () => import('@/pages/Setting/announcementManagement/compIndex'),
    meta: { title: 'cdp公告', index: 3 }
  },
  {
    path: '/surveyUnsubscribe',
    name: 'surveyUnsubscribe',
    hidden: true,
    component: () => import('@/pages/Survey/surveyUnsubscribe'),
    meta: { title: '退订', index: 3 }
  },
  {
    path: '/exportTemplateDetail',
    name: 'Template details',
    hidden: true,
    meta: {
      title: 'Template details', // 导航菜单显示的名称
      index: 3
    }, // 路由meta信息
    component: () =>
      import('@/pages/TemplateConfiguration/exportTemplateDetail')
  },
  {
    path: '/accessFailed',
    name: 'accessFailed',
    hidden: true,
    component: () => import('@/pages/System/accessFailed'),
    meta: { title: '访问失败', index: 3 }
  },
  {
    path: '/403',
    name: '403',
    hidden: true,
    component: () => import('@/pages/WarningPages/403'),
    meta: { title: 'P403', index: 3 }
  },
  {
    path: '*',
    name: '404',
    hidden: true,
    component: () => import('@/pages/WarningPages/404'),
    meta: { title: 'P404', index: 3 }
  },
  {
    path: '/500',
    hidden: true,
    name: '500',
    disabled: true,
    component: () => import('@/pages/WarningPages/500'),
    meta: { title: 'P500', index: 4 }
  }
]

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    base: '/v2/front/',
    routes
  })

const router = createRouter()
store.commit('app/setTagRoutes', [])
store.commit('app/setActiveTagRoute', '')
// 路由守卫
router.beforeEach((to, from, next) => {
  const matched = to.matched || []
  const { app } = store.state
  const tagRoutes = [...app.tagRoutes] || []
  matched.forEach((item, index) => {
    if (item.meta.isTag) {
      // 说明需要是页签页
      tagRoutes.filter((sitem) => sitem.path === item.path).length === 0 &&
        tagRoutes.push({
          path: item.path,
          name: item.name
        })
      store.commit('app/setTagRoutes', tagRoutes)
      store.commit('app/setActiveTagRoute', item.path)
    }
  })
  next()
})

// export function resetRouter() {
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher // reset router
// }

export default router
